export default "__VITE_ASSET__tXBgw1TL__"